module.exports = __webpack_public_path__ + "img/payment-methods.7c2232db.svg";